import apiClient from './apiClient';
import { API_ENDPOINTS } from './endpoints';

/** The signed-in admin's own account. */
const accountService = {
  /** Resolves on success; throws an Error with the server's message otherwise. */
  changePassword: async ({ adminId, currentPassword, newPassword }) => {
    const response = await apiClient.post(API_ENDPOINTS.ACCOUNT.CHANGE_PASSWORD, { adminId, currentPassword, newPassword });
    const body = response.data;
    if (!body || body.IsSuccess === false) throw new Error((body && body.Message) || 'Could not change the password');
    return body;
  },
};

export default accountService;
